import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from '@utils/constants';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html'
})
export class RankingComponent implements OnInit {

  public title = 'RANKING';
  public loading = true;
  public urlIframe = Constants.LINK_URL_RANKED;

  constructor(
    public dialogRef: MatDialogRef<RankingComponent>,
  ) {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

}
